import React, { useState } from "react";
import "../styles/Contact.css";
import ContactSection from "../components/ContactSection";
import Location from "../assets/footer/location.svg";
import emailIcon from "../assets/footer/email.svg";
import phoneIcon from "../assets/footer/phone.svg";
import axios from "axios";
import { FaClock } from "react-icons/fa";

const Contact = () => {
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const { full_name, email, phone, subject, message } = formData;

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post(
        "http://localhost/api/contact.php",
        formData
      );

      alert(res.data.message);

      if (res.data.success) {
        setFormData({
          full_name: "",
          email: "",
          phone: "",
          subject: "",
          message: "",
        });
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong.");
    }
  };

  return (
    <>
      <section className="contact-section">
        <div className="contact-container">
          {/* Header */}
          <div className="contact-header">
            <span className="contact-tag">Contact</span>

            <h2>
              Let's talk<span>.</span>
            </h2>

            <p>
              Have a project in mind? Reach out and let's discover how
              Grownex can help elevate your brand to new heights.
            </p>
          </div>

          {/* Contact Form */}
          <div className="contact-form-card">
            <h3>Send us a message</h3>

            <form onSubmit={handleSubmit}>
              <div className="form-grid">
                <div className="form-group">
                  <label>Full Name *</label>
                  <input
                    type="text"
                    name="full_name"
                    value={full_name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Email *</label>
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Phone</label>
                  <input
                    type="text"
                    name="phone"
                    value={phone}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label>Subject</label>
                  <select
                    name="subject"
                    value={subject}
                    onChange={handleChange}
                  >
                    <option value="">Select a topic</option>
                    <option value="Branding">Branding</option>
                    <option value="Web Development & UI/UX Design">
                      Web Development & UI/UX Design
                    </option>
                    <option value="Marketing">Marketing</option>
                    <option value="Video Production">
                      Video Production
                    </option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label>Your Message *</label>

                <textarea
                  rows="6"
                  name="message"
                  value={message}
                  onChange={handleChange}
                  placeholder="Tell us about your project..."
                  required
                ></textarea>
              </div>

              <button type="submit" className="submit-btn">
                Send Message ↗
              </button>

              <p className="policy-text">
                By submitting, you agree to our Terms and Privacy Policy.
              </p>
            </form>
          </div>

          {/* Contact Info */}
          <div className="contact-info">
            <div className="info-item">
              <div className="icon">
                <img src={Location} alt="Location" />
              </div>
              <div>
                <h4>Office</h4>
                <p>
                  4th Floor, Workflo - Oyo, Bziness Sphere, Jubilee Enclave,
                  Madhapur, Hyderabad, Telangana 500081
                </p>
              </div>
            </div>

            <div className="info-item">
              <div className="icon">
                <img src={phoneIcon} alt="Phone" />
              </div>
              <div>
                <h4>Phone</h4>
                <p>+91 6281981832</p>
              </div>
            </div>

            <div className="info-item">
              <div className="icon">
                <img src={emailIcon} alt="Email" />
              </div>
              <div>
                <h4>Email</h4>
                <p>hello@grownex.in</p>
              </div>
            </div>

            <div className="info-item">
              <div className="icon">
                <FaClock className="clock-icon" />
              </div>

              <div>
                <h4>Working Hours</h4>
                <p>Mon – Sat: 9:00 am – 7:00 pm</p>
              </div>
            </div>

            <div className="quick-chat-card">
              <h3>Prefer a quick chat?</h3>

              <p>
                Schedule a 15-minute discovery call and let's explore how we can
                help your brand grow.
              </p>

              <a href="mailto:hello@grownex.in">
                hello@grownex.in ↗
              </a>
            </div>
          </div>
        </div>
      </section>

      <ContactSection />
    </>
  );
};

export default Contact;